import '~/assets/scss/product.scss'


import '~/js/modules/page-product';
import PieChart from '~/js/modules/pie-chart-product';
import StockChart from '~/js/modules/stock-chart';
import getSwiperSlider from '~/js/modules/slider';
import Tooltip from '~/js/modules/tooltip';
import Accordion from '~/js/modules/accordion';
import getScrollDirection from '~/js/helpers/get-scroll-direction';
import Highcharts from "highcharts";
import Pikaday from "pikaday";

import '~/js/modules/switches';
import '~/js/modules/tabs';
import SwitchStock from '~/js/modules/switch-stock';
import '~/js/modules/online-request';

window.addEventListener(`DOMContentLoaded`, () => {

    //Инициализация всплывающих окон для кнопки "Задать вопрос"
    let questionButton = document.querySelector('.js-tooltip-question');
    if (questionButton) {
        new Tooltip(questionButton);
    }

    let basket = document.querySelector(`#mobile-fixed-button`);
    if (basket) {
        let toggleBasketClass = () => {
            if (window.pageYOffset > 0) {
                basket.classList.add(`active`);
            } else {
                basket.classList.remove(`active`);
                basket.removeAttribute(`disabled`);
            }
        }
        toggleBasketClass();
        window.addEventListener(`scroll`, () => {
            toggleBasketClass();
        });
    };

    const tooltipButtons = document.querySelectorAll('.js-tooltip-buttons');
    if (tooltipButtons.length) {
        tooltipButtons.forEach((button) => {
            new Tooltip(button, {
                modifiers: [{
                    name: 'offset',
                    options: {
                        offset: [0, 0],
                    },
                }, ],
            });
        });
    }


    const accordions = document.querySelectorAll(`.accordion`);
    if (accordions.length) {
        accordions.forEach((accordion) => {
            if(!accordion.classList.contains('main-nav__list')) {
                new Accordion(accordion)
            }
        });
    }


    const productsBuyBtn = document.querySelector(`.products--buy .products__btn`);
    const formInner = document.querySelector(`.form__inner`);
    const pieChartBlocks = document.querySelectorAll(`.js-pie-block`);
    const stockChartBlocks = document.querySelectorAll(`.js-stock-chart-wrap`);
    const productsChartBlocks = document.querySelectorAll(`.products__chart-block`);

    const anchorLinks = document.querySelectorAll(`.anchor .anchor-nav__link`);
    const anchorBlock = document.querySelector(`.anchor`);
    const header = document.querySelector(`.header`);
    let anchorNames = [];

    const productsDisclaimer = document.querySelector(`.js-products-disclaimer`);
    const productsDisclaimerClose = document.querySelectorAll(`.js-disclaimer-close`);

    productsDisclaimerClose.forEach((close) => {
        close.addEventListener('click', function () {
            productsDisclaimer.classList.toggle('hidden');
        })
    });

    anchorLinks.forEach((link) => {
        let anchorName = link.getAttribute("data-anchor");
        anchorNames.push(anchorName);
    });

    anchorLinks.forEach((link) => link.addEventListener(`click`, (evt) => {
        evt.preventDefault();
        let elem = evt.currentTarget;
        let anchorName = elem.getAttribute("data-anchor");
        setTimeout(function() {
            anchorLinks.forEach((link) => link.classList.remove(`active`));
            elem.classList.add(`active`);
        }, 300);
        anchorNames.push(anchorName)
        let anchorElem = document.querySelector("#" + anchorName);
        if (anchorElem) {
            window.scrollTo({
                top: (anchorElem.getBoundingClientRect().top + pageYOffset - (header.offsetHeight + anchorBlock.offsetHeight)),
                behavior: 'smooth'
            });
        }
    }));

    let boxLoad = anchorBlock.getBoundingClientRect();
    let topLoad = boxLoad.top + pageYOffset;

    let i = 0;

    function schrollAnchor() {
        const down = getScrollDirection() === 1;
        const up = getScrollDirection() === -1;

        let box = anchorBlock.getBoundingClientRect();
        let topAnchorBlock = box.top + pageYOffset;
        let anchorElem = document.getElementById(anchorNames[i]);
        let anchorElemBox = anchorElem.getBoundingClientRect();
        let topAnchorElem = anchorElemBox.top + pageYOffset;

        let headerHeight = header.classList.contains('header--scrolled') ? (header.offsetHeight) : header.offsetHeight;

        if (down) {

            if ((topAnchorElem) < (topAnchorBlock + anchorBlock.offsetHeight * 2)) {
                anchorLinks.forEach((link) => link.classList.remove(`active`));
                document.querySelector(`[data-anchor=${anchorNames[i]}]`).classList.add(`active`);
                if (anchorLinks.length - 1 !== i) {
                    i++;
                }
            }
            if ((pageYOffset + headerHeight) >= topAnchorBlock) {
                anchorBlock.style.top = headerHeight + 'px';
                header.classList.add(`header--title`);
                if (header.classList.contains('header--title') && (pageYOffset + (header.offsetHeight)) >= (topAnchorBlock)) {
                    anchorBlock.classList.add(`anchor--scrolled`);
                    anchorBlock.style.top = headerHeight + 'px';
                }
            } else {
                anchorBlock.classList.remove(`anchor--scrolled`);
                anchorBlock.removeAttribute("style");
            }
        }
        if (up) {

            /* Активация пунктов меню при прокрутке */
            if (topAnchorBlock < (topAnchorElem + anchorElem.offsetHeight)) {
                anchorLinks.forEach((link) => link.classList.remove(`active`));
                document.querySelector(`[data-anchor=${anchorNames[i]}]`).classList.add(`active`);
                if (i !== 0) {
                    i--;
                }
            }

            if ((pageYOffset + headerHeight) <= topLoad) {
                anchorBlock.classList.remove(`anchor--scrolled`);
                anchorBlock.removeAttribute("style");
                header.classList.remove(`header--title`);
            } else {
                if (header.classList.contains('header--title')) {
                    anchorBlock.classList.add(`anchor--scrolled`);
                    anchorBlock.style.top = (header.offsetHeight) + 'px';
                }
            }
        }
    }

    window.addEventListener(`scroll`, schrollAnchor);

    const pieChartOptions = {
        chart: {
            type: `pie`,
            height: '410',
            width: '360',
            margin: 0,
            spacing: [0, 0, 0, 0],
            style: {
                fontFamily: `'Roboto Regular', 'Arial', sans-serif`,
            },
            events: {
                load() {
                    const data = this.series[0] ? this.series[0].data : null;

                    if (data) {
                        const selectedItem = this.series[0].data.filter((el) => el.visible && el.selected)[0];

                        if (selectedItem) {
                            const value = Highcharts.numberFormat(selectedItem.percentage, 2, '.');
                            this.title.textStr = value;
                            this.title.element.textContent = `${value}%`;
                        }
                    }

                    const points = this.series[0] ? this.series[0].points : null;

                    if (points) {
                        points.forEach((point) => {
                            point.graphic.element.style.color = point.color;
                        });
                    }
                },
                redraw() {
                    const data = this.series[0] ? this.series[0].data : null;

                    if (data) {
                        const selectedItem = this.series[0].data.filter((el) => el.visible && el.selected)[0];

                        document.querySelectorAll('.highcharts-point').forEach((p, index) => {
                            p.addEventListener('click', (evt) => {
                                if (document.querySelector('.js-pie-legend .active')) {
                                    document.querySelector('.js-pie-legend .active').classList.remove('active');
                                }
                                const legendItems = document.querySelectorAll('.charts__legend-item');
                                legendItems[index].classList.add('active');
                                const valueTitle = Highcharts.numberFormat(this.series[0].data[index].percentage, 2, '.');
                                this.title.textStr = valueTitle;
                                this.title.element.textContent = `${valueTitle}%`;
                            })
                        });

                        if (selectedItem) {
                            const value = Highcharts.numberFormat(selectedItem.percentage, 2, '.');
                            this.title.textStr = value;
                            this.title.element.textContent = `${value}%`;
                        } else {
                            this.title.textStr = ``;
                            this.title.element.textContent = ``;
                        }
                    }
                }
            }
        },
        colors: null,
        credits: {
            enabled: false
        },
        // https://jsfiddle.net/gh/get/jquery/1.7.2/highcharts/highcharts/tree/master/samples/highcharts/css/legend/
        // https://www.highcharts.com/docs/chart-design-and-style/style-by-css
        legend: {
            enabled: false,
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'top',
            y: 30,
            title: {
                text: 'Male name'
            },
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                center: [`50%`, `50%`],
                cursor: `pointer`,
                dataLabels: {
                    enabled: false
                },
                events: {
                    click: null
                        // click(evt) {
                        // }
                },
                showInLegend: true,
                innerSize: `87%`,
                size: `90%`,
                borderWidth: 0,
                slicedOffset: 20,
                states: {
                    select: {
                        borderWidth: 3,
                    },
                    hover: {
                        halo: {
                            size: 0,
                        }
                    }
                }
            },
        },
        responsiveRules: {
            plotOptions: {
                pie: {
                    innerSize: `91%`,
                },
            },
        },
        series: null,
        title: {
            align: `center`,
            margin: 0,
            style: {
                color: `#000000`,
                fontFamily: `'Roboto Light', 'Arial', sans-serif`,
                fontSize: `3.5rem`,
            },
            text: ``,
            useHTML: true,
            verticalAlign: `middle`,
            widthAdjust: 0,
        },
        tooltip: {
            pointFormat: `<b>{point.percentage:.2f}%</b>`,
            outside: true
        },
    };

    pieChartBlocks.forEach((chart) => new PieChart({
        chart,
        options: pieChartOptions,
    }));


    const stockChartOptions = {
        chart: {
            // animation: false,
            // height: 600,
            // marginTop: 25,
            // marginBottom: 25,
            // type: 'spline',
            marginLeft: 1,
            marginRight: 1,
            spacing: 0,
            plotBorderWidth: 1,
            plotBorderColor: `#919aa6`,
            style: {
                fontFamily: `'Roboto Regular', 'Arial', sans-serif`,
            },
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: false,
            align: `left`,
            itemDistance: 30,
            itemStyle: {
                color: `#000000`,
                fontWeight: `400`,
                fontSize: `1.625rem`,
            },
            margin: 0,
            padding: 0,
            symbolPadding: 10,
            useHTML: true,
            y: -10,
        },
        navigator: {
            height: 54,
            handles: {
                width: 20,
                height: 20,
                symbols: [
                    `url(assets/dist/img/i-chart-handle.svg)`,
                    `url(assets/dist/img/i-chart-handle.svg)`
                ],
            },
            outlineColor: `#d1d7db`,
            xAxis: {
                labels: {
                    align: `center`,
                    style: {
                        color: `#75808f`,
                        fontSize: `1.25rem`,
                    },
                    // x: 0,
                    y: -20,
                },
                // tickInterval: 1.1 * 365 * 24 * 60 * 60 * 1000,
                units: [
                    [
                        'month', [3]
                    ],
                    [`year`, null],
                ],
            }
        },
        plotOptions: {
            // series: {
            //   animation: false
            // },
            line: {
                showInNavigator: true,
            }
        },
        rangeSelector: {
            enabled: true,
            floating: true,
            y: -50,
            x: 0,
            selected: 7,
            buttons: [{
                    type: 'month',
                    count: 1,
                    text: '1m'
                }, {
                    type: 'month',
                    count: 3,
                    text: '3m'
                }, {
                    type: 'month',
                    count: 6,
                    text: '6m'
                },
                {
                    type: 'ytd',
                    text: 'YTD'
                }, {
                    type: 'year',
                    count: 1,
                    text: '1y'
                }, {
                    type: 'year',
                    count: 3,
                    text: '3y'
                }, {
                    type: 'year',
                    count: 5,
                    text: '5y'
                }, {
                    type: 'all',
                    text: 'All'
                }
            ],
            buttonPosition: {
                align: `right`,
                // x: 0,
            },
            inputEnabled: false,
            inputPosition: {
                align: `left`,
                x: 0,
            },
            // inputBoxWidth: 100,
            // inputBoxHeight: 40,
            inputDateFormat: `%d.%m.%Y`,
            inputEditDateFormat: `%d.%m.%Y`,
        },
        responsiveRules: {
            navigator: {
                xAxis: {
                    labels: {
                        style: {
                            fontSize: `0.875rem`,
                        },
                    },
                },
            },
            legend: {
                itemDistance: 60,
                itemStyle: {
                    fontSize: `1.125rem`,
                },
                symbolPadding: 20,
            },
            xAxis: {
                labels: {
                    style: {
                        fontSize: `0.875rem`,
                    },
                },
            },
            yAxis: {
              // посмотрим, на что влияет, потом может придётся вернуть
                // tickPositioner: function() {
                //     let positions = []
                //     const dataMin = this.dataMin
                //     const dataMax = this.dataMax
                //     let tick = Math.floor(dataMin)
                //     const increment = Math.ceil((dataMax - dataMin) / 6)
                //
                //     if (dataMax !== null && dataMin !== null) {
                //         for (tick; tick - increment <= dataMax; tick += increment) {
                //             positions.push(tick);
                //         }
                //     }
                //     tick += 0;
                //     positions.push(tick);
                //     return positions;
                // },
                labels: {
                    // format: "{value}",
                    formatter: function() {
                        return this.value.toLocaleString();
                    },
                    style: {
                        fontSize: `0.875rem`,
                    },
                    x: 20,
                    y: -8,
                },
            },
        },
        scrollbar: {
            enabled: false,
        },
        tooltip: {
            headerFormat: "",
            xDateFormat: '%d.%m.%Y',
            pointFormatter() {
                const value = this.y.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                const beginItem = this.series.cropStart ? this.series.yData[this.series.cropStart + 1] : this.series.yData[this.series.cropStart];
                const diff = (this.y / beginItem * 100 - 100).toFixed(2);
                let date = new Date(this.x).toLocaleDateString('ru-RU', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
                date = date[0].toUpperCase() + date.slice(1);

                return `
            <b >${date}</b><br/>
            <span style="color:${this.series.color}">${this.series.name}: <b>${value}</b></span><br/>
            <span style="color:${this.series.color}">Прирост: </span><b>${diff}%</b>`;
            },
            valueDecimals: 2,
            split: true,
        },
        xAxis: {
            events: {
                afterSetExtremes(evt) {
                    stockChartCallbacks.afterSetExtremes(evt);
                }
            },
            id: `navigatorXAxis`,
            gridLineWidth: 1,
            showFirstLabel: true,
            gridLineColor: `#d1d7db`,
            labels: {
                style: {
                    color: `#75808f`,
                    fontSize: `1.25rem`,
                },
            },
            // lineWidth: 1,
            // lineColor: `#919aa6`,
            // overscroll: 2 * 24 * 60 * 60 * 1000,
            // tickLength: 0,
            units: [
                [
                    'month', [3]
                ],
                [`year`, null],
            ],
        },
        yAxis: {
            opposite: false,
            gridLineWidth: 1,
            gridLineColor: `#d1d7db`,
            labels: {
                align: `left`,
                style: {
                    color: `#75808f`,
                    fontSize: `1.25rem`,
                },
                x: 10,
                y: -10,
            },
            // min: 1000,
        },
        // yAxis: [
        //   {
        //     labels: {
        //       align: 'right',
        //       x: -3
        //     },
        //     title: {
        //       text: 'Стооимость пая'
        //     },
        //     height: '50%',
        //     lineWidth: 2,
        //     resize: {
        //       enabled: true
        //     }
        //   }, {
        //     labels: {
        //       align: 'right',
        //       x: -3
        //     },
        //     title: {
        //       text: 'Стооимость СЧА'
        //     },
        //     top: '50%',
        //     height: '45%',
        //     offset: 0,
        //     lineWidth: 2
        //   }
        // ],
        series: [],
        seriesCounter: 0,
    };

    const stockChartCallbacks = {};

    stockChartBlocks.forEach((chart) => {
        new StockChart({
            chart,
            options: stockChartOptions,
            callbacks: stockChartCallbacks,
        });
    });

    // const calculators = document.querySelectorAll(`.calculator`);
    // const calculatorOptions = {
    //   start: 49000000,
    //   connect: [true, false],
    //   step: 10000,
    //   range: {
    //     [`min`]: 10000,
    //     [`max`]: 100000000
    //   },
    //   pips: {
    //     mode: `range`,
    //     density: -1
    //   }
    // };
    //
    // let calculatorDateValues = undefined;
    // let calculatorPercentage = undefined;
    //
    // if (typeof calc_data !== `undefined`) {
    //   const endDate = new Date(); // текущая дата
    //   const startDate = new Date(+endDate - 1000 * 60 * 60 * 24 * 31); // дата на 31 день назад от текущей
    //
    //   calculatorDateValues = {
    //     start: {
    //       date: startDate,
    //       value: parseInt(calc_data[0].pie1, 10)
    //     },
    //     end: {
    //       date: endDate,
    //       value: parseInt(calc_data[0].pie2, 10)
    //     }
    //   };
    //   calculatorPercentage = parseInt(calc_data[0].pie_percent, 10);
    // }
    //
    // if (calculators.length) {
    //   calculators.forEach((calc) => new Calculator({
    //     calc,
    //     dateValues: calculatorDateValues,
    //     percentage: calculatorPercentage,
    //     rangeOptions: calculatorOptions,
    //   }));
    // }

    // const forms = document.querySelectorAll(`.form__form`);
    //
    // if (forms.length) {
    //    forms.forEach((form) => new Form(form));
    // }

    const productsSlider = document.querySelector(`.products__slider`);
    const productsSliderMobile = document.querySelector(`.products__slider-mobile`);
    let productsSwiper;
    let productsSwiperMobile;

    const productsSwiperParams = {
        slidesPerView: `auto`,
        loop: false,
        autoplay: false,
        pagination: false,
    };

    if (productsSlider) {
        productsSwiper = getSwiperSlider(productsSlider, productsSwiperParams);
    }

    if (productsSliderMobile) {
        productsSwiperMobile = getSwiperSlider(productsSliderMobile, productsSwiperParams);
    }

    const productsStockChartOptions = {
        credits: {
            enabled: false,
        },
        legend: {
            enabled: false,
        },
        navigator: {
            enabled: false,
        },
        plotOptions: {
            line: {
                enableMouseTracking: false
            },
        },
        rangeSelector: {
            enabled: false,
        },
        scrollbar: {
            enabled: false,
        },
        tooltip: {
            enabled: false,
        },
        xAxis: {
            crosshair: false,
            labels: {
                enabled: false,
            },
            lineWidth: 0,
            range: 365 * 24 * 60 * 60 * 1000, // 1 year
            tickLength: 0,
        },
        yAxis: {
            gridLineWidth: 0,
            labels: {
                enabled: false,
            },
        },
        series: [],
        seriesCounter: 0,
    };

    productsChartBlocks.forEach((chart, i) => {
        productsStockChartOptions.chart = {
            spacing: 0,
            width: chart.offsetWidth,
            height: chart.offsetHeight,
        };
        if (chart.querySelector(`.js-stock-chart`)) {
            return new StockChart({
                chart,
                options: productsStockChartOptions,
            });
        }
    });

    const question__title = document.querySelector(`.question__title`);
    question__title.innerHTML = 'Остались вопросы? Получите консультацию специалиста';

  let elem = document.querySelectorAll('.js-pie-chart-datepicker');
  if (elem) {
    elem.forEach((el) => {
      let min = new Date(el.dataset.min);
      let max = new Date();
      let picker = new Pikaday({
        field: el,
        keyboardInput: false,
        minDate: min,
        maxDate: max,
        format: 'DD.MM.YYYY',
        toString(date, format) {
          let day = date.getDate();
          if (day < 10) {
            day = '0' + day;
          }
          let month = date.getMonth() + 1;
          if (month < 10) {
            month = '0' + month;
          }
          let year = date.getFullYear();
          return year + '-' + month + '-' + day;
        },
        parse(dateString, format) {
          const parts = dateString.split('/');
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1] - 1, 10);
          const year = parseInt(parts[1], 10);
          return new Date(year, month, day);
        },
        i18n: {
          previousMonth: 'Предыдущий месяц',
          nextMonth: 'Следующий месяц',
          months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
          weekdays: ['Воскресерье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
          weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
        },
      });
    })
  }

    const stock = document.querySelectorAll(`.js-stocks-container`)
    const preloads = document.querySelectorAll('.charts__block-waiting')
  if (stock) {
      if (preloads) {
          preloads.forEach((p) => {
              p.remove()
          })
      }

      new SwitchStock({ container: 'stocksA', mode: 'slider' });
  }


  const isinCopyBtns = document.querySelectorAll(`.js-isin-btn`);
  if (isinCopyBtns) {
      isinCopyBtns.forEach((item) => {
        let isinLabel = item.querySelector('span');
        isinLabel.addEventListener('mouseover', function () {
            let helpbox = document.createElement("div");
            helpbox.className = 'help-box js-help-box';
            helpbox.innerHTML = "Скопировать";
            item.appendChild(helpbox);
        });
        isinLabel.addEventListener('mouseout', function () {
            document.querySelectorAll(".js-help-box").forEach((helpbox) => {
                helpbox.classList.add('help-box-fadeout');
                item.removeChild(helpbox);
            })
        });
        isinLabel.addEventListener('click', function () {
        let text = isinLabel.innerHTML;
        let copyhelper = document.createElement("input");
        document.body.appendChild(copyhelper);
        copyhelper.value = text;
        copyhelper.select();
        document.execCommand("copy");
        document.body.removeChild(copyhelper);
      })
    })
  }
});
